export var PromotionExternalAmountTypeEnum;
(function (PromotionExternalAmountTypeEnum) {
    PromotionExternalAmountTypeEnum["PERCENT"] = "percent";
    PromotionExternalAmountTypeEnum["FIXED"] = "fixed";
    PromotionExternalAmountTypeEnum["OPEN"] = "open";
})(PromotionExternalAmountTypeEnum || (PromotionExternalAmountTypeEnum = {}));
//# sourceMappingURL=PromotionExternalAmountTypeEnum.js.map